import { useEffect } from "react";
import PrivacyPolicy from "../components/Terms/PrivacyPolicyComponent";
import TermsConditions from "../components/Terms/TermsConditionComponent";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Terms & Conditions | Halo Holidays</title>
          <meta
            name="description"
            content="Read our terms and conditions for booking your holiday with Halo Holidays."
          />
        </Helmet>
      </HelmetProvider>

      <Header />

      <div className="container mx-auto mt-20 p-4 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
          Terms <span className="text-halo-pink">&</span> Conditions
        </h1>

        <section className="mb-16 shadow-sm p-6 bg-gray border border-gray-200 rounded-lg">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Privacy Policy
          </h2>
          <PrivacyPolicy />
        </section>

        <section className="mb-16 shadow-sm p-6 bg-gray border border-gray-200 rounded-lg">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Cookie Policy
          </h2>
          <TermsConditions />
        </section>
      </div>

      <Footer />
    </>
  );
};

export default TermsPage;
